enum FileType {
  MP3 = `mp3`,
  WAV = `wav`,
  MP4 = `mp4`,
}

export default FileType;
